export const ACTIONS = {
    UPDATE_RESTORE_STATE: 'UPDATE_RESTORE_STATE',
    UPDATE_APPLICATIONS_LIST: 'UPDATE_APPLICATIONS_LIST',
    UPDATE_APPLICATION_DETAILS: 'UPDATE_APPLICATION_DETAILS',
    REMOVE_APPLICATION: 'REMOVE_APPLICATION',
    LOAD_APPLICATION: 'LOAD_APPLICATION',
    UPDATE_APPLICATION_PROPS: 'UPDATE_APPLICATION_PROPS',
    REPLACE_SITE_IDS: 'REPLACE_SITE_IDS',
    ADD_SITES: 'ADD_SITES',
    UPDATE_SITES: 'UPDATE_SITES',
    DELETE_SITES: 'DELETE_SITES',
    UPDATE_EDIT_SHAPES_STATUS: 'UPDATE_EDIT_SHAPES_STATUS',
    UPDATE_DETAILS_STATUS: 'UPDATE_DETAILS_STATUS',
    UPDATE_REPORT_DATA_STATUS: 'UPDATE_REPORT_DATA_STATUS'
}

export function updateRestoreState(isRestoring) {
    return {
        type: ACTIONS.UPDATE_RESTORE_STATE,
        isRestoring
    }
}

export function updateReportDataStatus(isReadyForReport) {
    return {
        type: ACTIONS.UPDATE_REPORT_DATA_STATUS,
        isReadyForReport
    }
}

export function updateDetailsStatus(isUpdated) {
    return (dispatch) => {
        if (isUpdated) {
            dispatch(updateReportDataStatus(false))
        }
        dispatch({
            type: ACTIONS.UPDATE_DETAILS_STATUS,
            isUpdated
        })
    }
}

export function updateApplicationsList(applications) {
    return {
        type: ACTIONS.UPDATE_APPLICATIONS_LIST,
        applications
    }
}

export function loadApplication(applicationId = null) {
    return {
        type: ACTIONS.LOAD_APPLICATION,
        applicationId
    }
}

export function updateApplicationDetails(application) {
    return {
        type: ACTIONS.UPDATE_APPLICATION_DETAILS,
        application
    }
}

export function removeApplication(applicationId) {
    return {
        type: ACTIONS.REMOVE_APPLICATION,
        applicationId
    }
}

export function updateApplicationProps(props) {
    return (dispatch) => {
        if (!props.mapImage) {
            dispatch(updateDetailsStatus(true))
        }
        dispatch({
            type: ACTIONS.UPDATE_APPLICATION_PROPS,
            props
        })
    }
}

export function replaceSiteIds(siteIds) {
    return (dispatch) => {
        dispatch(updateDetailsStatus(true))
        dispatch({
            type: ACTIONS.REPLACE_SITE_IDS,
            siteIds
        })
    }
}

export function addSites(sites) {
    return (dispatch) => {
        dispatch(updateDetailsStatus(true))
        dispatch({
            type: ACTIONS.ADD_SITES,
            sites
        })
    }
}

export function updateSites(sites) {
    return (dispatch) => {
        dispatch(updateDetailsStatus(true))
        dispatch({
            type: ACTIONS.UPDATE_SITES,
            sites
        })
    }
}

export function deleteSites(sites) {
    return (dispatch) => {
        dispatch(updateDetailsStatus(true))
        dispatch({
            type: ACTIONS.DELETE_SITES,
            sites
        })
    }
}



// WEBPACK FOOTER //
// ./source/containers/Surveys/actions/conservationActions.js